module.exports = __webpack_public_path__ + "static/3-52881e4a8a1375ecf6b106c73e8df7a9.jpg";